import React from "react";
import { DoorOpenFill } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import imgLogo from "../../assets/logo-reina.png";
import { Logout } from "../../utils/logout";
import "./lottery-bet-modern.css";
import "./pos-sections.css";

const sections = [
  { id: "bet", label: "VENTA", to: "/bet" },
  { id: "line", label: "LÍNEA", to: "/line" },
  { id: "history", label: "RESULTADOS", to: "/history" },
  { id: "venta", label: "VOLUMEN DE VENTAS", to: "/venta" },
  { id: "player", label: "JUGADORES", to: "/player" },
];

function PosNavigation({ active }) {
  return (
    <div className="queen-pos-header noPrint">
      <div className="queen-pos-title">
        <img src={imgLogo} alt="La Reina" />
        <div>
          <span>RAPIDITA</span>
          <h1>LA REINA</h1>
        </div>
      </div>
      <header className="queen-pos-header-inner">
        <nav className="queen-pos-nav" aria-label="Navegación del punto de venta">
          <div className="queen-pos-nav-links">
            {sections.map((section) => (
              <Link
                key={section.id}
                to={section.to}
                className={`vol${active === section.id ? " is-active" : ""}`}
                aria-current={active === section.id ? "page" : undefined}
              >
                {section.label}
              </Link>
            ))}
            <button
              type="button"
              className="boton_menu"
              onClick={Logout}
              aria-label="Cerrar sesión"
              title="Cerrar sesión"
            >
              <DoorOpenFill aria-hidden="true" />
            </button>
          </div>
        </nav>
      </header>
    </div>
  );
}

export default PosNavigation;
